import { ChangeDetectorRef, Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faSearch,
  faTh,
  faTachometerAlt,
  faChartLine,
  faAngleLeft,
  faAngleRight,
  faStepBackward,
  faStepForward,
  faCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
Chart.register(...registerables);
Chart.register(ChartDataLabels);
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  faTh = faTh;
  faTachometerAlt = faTachometerAlt;
  faChartLine = faChartLine;
  faInfoCircle = faInfoCircle;
  faCircle = faCircle;
  faSearch = faSearch;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;

  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  listofSelectedModules: any = [];


  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private Config: Config,
    private appService: AppService,
    private _cdr: ChangeDetectorRef,
    private pagerService: PagerService
  ) {
    // @ViewChild('mychart') mychart: any;
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
    $("iframe").each(() => {
      var src = $(this).attr('src');
      $(this).attr('src', src);
    });

  }

  modelData: any;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  eutCountPieChart: any = '';
  levelwiseCountChart: any = '';
  attrwiseCountChart: any = '';
  typewiseCountChart: any = '';
  filteredEUTs: any = [];
  listofEUTtypes: any = ["TF", "UR", "BF", "XX"];
  listOfSelectedEUTtypes: any = ["TF", "UR", "BF", "XX"];
  /// app open
  eutCollection: any = { TF: [], UR: [], BF: [], XX: [] };
  listOfEUTs: any;
  scenarios: any;
  runInfo: any;
  /// app close

  /// model open
  model: any = {
    startAt: 0,
    eutType: 'TF',
    db: 'testCaseQuality',
    maxColumns: 15,
    maxRows: 10,
    listLength: 10,
    dashboards: {},
    dashboardsUI: {},
    attributes: [],
    deSelectCollection: {},
  };

  /// model close

  /// controller open
  disableDown: any;
  disableUp: any;
  /// controller close

  dashBoardName: any = 'Test Dashboard';
  eutType: any = '';
  startAt = 0;

  ngOnInit(): void {
    // console.log('db init');
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    setTimeout(() => {
      this.getVideoURL('testCaseQuality')
    }, 2000);
    this.modelData = this._sharedService.loadedProjectData.model;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.scenarios = this.modelData.scenarios;
    this.runInfo = this.modelData.runInfo;
    for (var i = 0; i < this.modelData.modules.length; i++) {
      this.listofSelectedModules.push(this.modelData.modules[i].mID);
    }
    this.eutCollection['TF'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.eutCollection['UR'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.eutCollection['BF'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );
    this.eutCollection['XX'] = this.modelData.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'XX'
    );
    this.allItems = this.eutCollection['TF'];
    this.setPage(1);

    //// model load

    this.model.dashboards = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [], XX: [] },
    };

    this.model.dashboardsUI = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [], XX: [] },
    };

    this.model.totalOfDashboardUI = {
      testCaseQuality: { TF: [], UR: [], BF: [], XX: [] },
      testExecutionQuality: { TF: [], UR: [], BF: [], XX: [] },
      cleanlinessDegree: { TF: [], UR: [], BF: [], XX: [] },
    };
    this.model.deSelectCollection = { TF: [], UR: [], BF: [], XX: [] };
    this.model.attributes = this.Config.listOfAttributesUpdated;
    this.loadDashboards();
    this.loadDashboardsUI();
    this.isUpDownValid();
    this.reloadToolService.triggerSmartChecklist('');
    this.generateGraphs();
  }

  generateGraphs() {
    this.filteredEUTs = [];
    for (var i = 0; i < this.listofSelectedModules.length; i++) {
      for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
        if (this.listofSelectedModules[i] == this.modelData.listOfEUTs[j].mID) {
          var isPresent = this.listOfSelectedEUTtypes.findIndex((a: any) => a == this.modelData.listOfEUTs[j].eType);
          if (isPresent > -1) {
            this.filteredEUTs.push(this.modelData.listOfEUTs[j]);
          }
        }
      }
    }
    this.generateEUTCountCharts();
    this.generateLevelwiseCharts();
    this.generateAttrwiseCharts();
    this.generatetypeWiseCharts();

  }

  isCheckedeutType(eut: any) {
    if (this.listOfSelectedEUTtypes.length > 0) {
      var a = this.listOfSelectedEUTtypes.findIndex((a: any) => a == eut);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  isCheckedmodule(mID: any) {
    if (this.listofSelectedModules.length > 0) {
      var a = this.listofSelectedModules.findIndex((a: any) => a == mID);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }
  // function is used for EUT filter
  addToEUTFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.listOfSelectedEUTtypes.push(id);
    } else {
      var isPresent = this.listOfSelectedEUTtypes.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.listOfSelectedEUTtypes.splice(isPresent, 1);
      }
    }
    this.eutCountPieChart.destroy();
    this.levelwiseCountChart.destroy();
    this.attrwiseCountChart.destroy();
    this.typewiseCountChart.destroy();
    this.generateGraphs();

  }
  // function is used for module filter
  addToModuleFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.listofSelectedModules.push(id);
    } else {
      var isPresent = this.listofSelectedModules.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.listofSelectedModules.splice(isPresent, 1);
      }
    }
    this.eutCountPieChart.destroy();
    this.levelwiseCountChart.destroy();
    this.attrwiseCountChart.destroy();
    this.typewiseCountChart.destroy();
    this.generateGraphs();

  }
  generateEUTCountCharts() {
    var countTF = 0;
    var countUR = 0;
    var countBF = 0;
    var countXX = 0;
    var modulesEUTcount = [];
    for (var i = 0; i < this.listofSelectedModules.length; i++) {
      for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
        if (this.listofSelectedModules[i] == this.modelData.listOfEUTs[j].mID) {
          var type = this.modelData.listOfEUTs[j].eType;
          var isPresent = this.listOfSelectedEUTtypes.findIndex((a: any) => a == type);
          if (isPresent > -1) {
            if (type == 'TF') {
              countTF++;
            } else if (type == 'UR') {
              countUR++;
            } else if (type == 'BF') {
              countBF++;
            } else if (type == 'XX') {
              countXX++;
            }
          }
        }
      }

    }
    modulesEUTcount.push(countTF, countUR, countBF, countXX);
    this.eutCountPieChart = new Chart("EntitypieChart", {
      type: 'pie',
      data: {
        labels: ["TF", "UR", "BF", "XX"],
        datasets: [
          {
            data: modulesEUTcount,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(255, 205, 86)', 'rgb(255, 125, 186)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: function (value, context: any) {
              return value === 0 ? '' : value;
              // return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";

            },
            // align: 'start', // or 'end' for right-aligned labels
            // anchor: 'start', // or 'end' for right-aligned labels
            // offset: 4, // adjust the offset value as needed
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },

          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'white', // Set the legend text color to white
            },
          },
          title: {
            display: true,
            text: "Entity distribution by Type",
            font: {
              weight: 'bold'
            },
            color: 'white'
          }
        }
      },
    });
  };
  generateLevelwiseCharts() {
    var countL8 = 0;
    var countL7 = 0;
    var countL6 = 0;
    var countL5 = 0;
    var countL4 = 0;
    var countL123 = 0;
    var levelsScenarioCount = [];
    for (var k = 0; k < this.filteredEUTs.length; k++) {
      for (var l = 0; l < this.modelData.scenarios.length; l++) {
        if (this.filteredEUTs[k].eID == this.modelData.scenarios[l].eID) {
          var level = this.modelData.scenarios[l].attribute.level;
          if (level == 'L8') {
            countL8++;
          } else if (level == 'L7') {
            countL7++;
          } else if (level == 'L6') {
            countL6++;
          } else if (level == 'L5') {
            countL5++;
          } else if (level == 'L4') {
            countL4++;
          } else if (level == 'L123') {
            countL123++;
          }
        }
      }
    }
    levelsScenarioCount.push(countL8, countL7, countL6, countL5, countL4, countL123)
    this.levelwiseCountChart = new Chart("LevelCountPieChart", {
      type: 'bar',
      data: {
        labels: ["L8", "L7", "L6", "L5", "L4", "L123"],
        datasets: [
          {
            data: levelsScenarioCount,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(255, 205, 86)', 'rgb(255, 125, 186)', '#8e3a3b', '#38f77d']
          }
        ]
      },
      options: {
        scales: {
          x: {
            // beginAtZero: true,
            grid: {
              color: 'white',
              // color: (context) => (context.index === 0 ? 'white' : 'rgba(0, 0, 0, 0)'), // Hide all grid lines except the first one
            },
            title: {
              color: 'white', // Set the x-axis title color to white
            },
            ticks: {
              color: 'white', // Set the x-axis tick color to white
            },
          },
          y: {
            // beginAtZero: true, 
            grid: {
              color: 'white',
              // color: (context) => (context.index === 0 ? 'white' : 'rgba(0, 0, 0, 0)'), // Hide all grid lines except the first one
            },
            title: {
              color: 'white', // Set the y-axis title color to white
            },
            ticks: {
              color: 'white', // Set the y-axis tick color to white
            },
          },
        },
        responsive: true,
        indexAxis: 'y',
        plugins: {
          datalabels: {
            formatter: function (value, context: any) {
              return value === 0 ? '' : value;
              // return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";

            },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },

          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Test cases distribution by Level",
            font: {
              weight: 'bold',
            },
            color: 'white'
          }
        }
      },
    });
  };


  generateAttrwiseCharts() {
    // var countMi = 0;
    // var countIn = 0;
    // var countCo = 0;
    // var countSi = 0;
    // var countPf = 0;
    // var countLo = 0;
    // var countRe = 0;
    // var countSe = 0;
    // var countUs = 0;
    // var countBc = 0;
    // var countEc = 0;
    // var countAc = 0;
    // var countUi = 0;
    // var countSt = 0;
    var countFe = 0;
    var countRb = 0;
    var countFb = 0;
    var countLs = 0;
    var countPf = 0;
    var countSe = 0;
    var countUs = 0;
    var countCm = 0;
    var countVo = 0;
    var countRe = 0;
    var countMi = 0;
    var attributeScenarioCount = [];
    for (var k = 0; k < this.filteredEUTs.length; k++) {
      for (var l = 0; l < this.modelData.scenarios.length; l++) {
        if (this.filteredEUTs[k].eID == this.modelData.scenarios[l].eID) {
          var symbol = this.modelData.scenarios[l].attribute.symbol;
          if (symbol == 'Ls') {
            countLs++;
          } else if (symbol == 'Pf') {
            countPf++;
          } else if (symbol == 'Se') {
            countSe++;
          } else if (symbol == 'Us') {
            countUs++;
          } else if (symbol == 'Cm') {
            countCm++;
          } else if (symbol == 'Vo') {
            countVo++;
          } else if (symbol == 'Re') {
            countRe++;
          } else if (symbol == 'Mi') {
            countMi++;
          } else if (symbol == 'Fe') {
            countFe++;
          } else if (symbol == 'Rb') {
            countRb++;
          } else if (symbol == 'Fb') {
            countFb++;
          }
        }
      }
    }
    attributeScenarioCount.push(countFe, countRb, countFb, countLs, countPf, countSe, countUs, countCm, countVo, countRe, countMi);
    this.attrwiseCountChart = new Chart("AttrCountPieChart", {
      type: 'bar',
      data: {
        labels: ["Fe", "Rb", "Fb", "Ls", "Pf", "Se", "Us", "Cm", "Vo", "Re", "Mi"],
        datasets: [
          {
            data: attributeScenarioCount,
            backgroundColor: ['#bb029c', '#2ef28c', '#b8d903', '#293462', '#a64942', '#fe5f55', '#fff1c1', '#5BE7C4', '#266A2E', '#5bd1d7', '#ff502f', '#004d61', '#ff8a5c', '#fff591', '#f5587b', '#fad3cf', '#a696c8'],
            //   hidden: function(context: any) {
            //     return context.dataset.data[context.dataIndex] === 0;
            // }
          }
        ]
      },
      options: {
        scales: {
          x: {
            // beginAtZero: true,
            grid: {
              color: 'white',
              // color: (context) => (context.index === 0 ? 'white' : 'rgba(0, 0, 0, 0)'), // Hide all grid lines except the first one
            },
            title: {
              color: 'white', // Set the x-axis title color to white
            },
            ticks: {
              color: 'white', // Set the x-axis tick color to white
            },
          },
          y: {
            // beginAtZero: true, 
            grid: {
              color: 'white',
              // color: (context) => (context.index === 0 ? 'white' : 'rgba(0, 0, 0, 0)'), // Hide all grid lines except the first one
            },
            title: {
              color: 'white', // Set the y-axis title color to white
            },
            ticks: {
              color: 'white', // Set the y-axis tick color to white
            },
          },
        },
        responsive: true,
        indexAxis: 'y',
        // scales: {
        //   x:
        //   {
        //     stacked: true,
        //     grid: {
        //       drawBorder: false,
        //       color: function (context) {
        //         if (context.tick.value == 0) {
        //           return '#000000';
        //         } else {
        //           return '#DCDBDB';
        //         }

        //       },
        //     },
        //     ticks: {
        //       display: false,
        //     }
        //   }

        // },
        plugins: {
          datalabels: {
            formatter: function (value, context: any) {
              return value === 0 ? '' : value;
              // return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";

            },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },

          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Test cases distribution by Test type",
            font: {
              weight: 'bold'
            },
            color: 'white'
          }
        }
      },
    });
  };
  generatetypeWiseCharts() {
    var countPositive = 0;
    var countNegative = 0;
    var typeScenarioCount = [];
    for (var k = 0; k < this.filteredEUTs.length; k++) {
      for (var l = 0; l < this.modelData.scenarios.length; l++) {
        if (this.filteredEUTs[k].eID == this.modelData.scenarios[l].eID) {
          var type = this.modelData.scenarios[l].cr;
          if (type == '+') {
            countPositive++;
          } else if (type == '-') {
            countNegative++;
          }
        }
      }
    }
    // console.log(countPositive,countNegative)
    typeScenarioCount.push(countPositive, countNegative)
    this.typewiseCountChart = new Chart("TypeCountPieChart", {
      type: 'pie',
      data: {
        labels: ["+ve", "-ve"],
        datasets: [
          {
            data: typeScenarioCount,
            backgroundColor: ['rgb(255, 205, 86)', 'rgb(255, 125, 186)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: function (value, context: any) {
              return value === 0 ? '' : value;
              // return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";

            },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },

          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'white', // Set the legend text color to white
            },
          },
          title: {
            display: true,
            text: "Test cases distribution by +ve/-ve",
            font: {
              weight: 'bold'
            },
            color: 'white'
          }
        }
      },
    });
  };

  //sort by alphabetical order
  sortBy(prop: string) {
    return this.modelData.modules.sort((a: any, b: any) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }
  setPage(page: number) {
    // get pager object from servicesetPage
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  //// model fn open

  loadDashboards() {
    // console.log('this.model', this.model);

    for (var dashboard in this.model.dashboards) {
      for (var eut in this.model.dashboards[dashboard]) {
        this.model.dashboards[dashboard][eut] = [];
        this.model.attributes.forEach((attribute: any) => {
          var eutList: any = [];
          this.eutCollection[eut].forEach((anEut: any) => {
            var count: any;
            switch (dashboard) {
              case 'testCaseQuality':
                count = this.getScenarioCountForEntity(anEut, attribute.symbol);
                eutList.push({ eID: anEut.eID, count });
                break;
              case 'testExecutionQuality':
                count = this.getScenarioExecutedForEntity(
                  anEut,
                  attribute.symbol
                );
                eutList.push({ eID: anEut.eID, count });
                break;
              case 'cleanlinessDegree':
                count = this.getScenarioPassedForEntity(
                  anEut,
                  attribute.symbol
                );
                eutList.push({ eID: anEut.eID, count });
                break;
              default:
                break;
            }
          });
          var test = this.getTotalForAnAttribute(attribute, dashboard);
          this.model.dashboards[dashboard][eut].push({
            name: attribute,
            eutList,
            test,
          });
        });
      }
    }
    // console.log('this.model1', this.model);
  }




  loadDashboardsUI() {
    for (var dashboard in this.model.dashboardsUI) {
      for (var eut in this.model.dashboardsUI[dashboard]) {
        this.model.dashboardsUI[dashboard][eut] = $.extend(
          true,
          [],
          this.model.dashboards[dashboard][eut]
        );
        this.model.dashboardsUI[dashboard][eut].forEach((attribute: any) => {
          for (
            i = attribute.eutList.length - 1;
            i >= this.model.startAt;
            i -= 1
          ) {
            var idExist = this.model.deSelectCollection[eut].find(
              (id: any) => id == attribute.eutList[i].eID
            );
            if (idExist) {
              attribute.eutList.splice(i, 1);
            }
          }

          attribute.eutList.splice(0, this.model.startAt);
          if (attribute.eutList.length > this.model.maxColumns) {
            attribute.eutList.splice(
              this.model.maxColumns,
              attribute.eutList.length - this.model.maxColumns
            );
          }

          for (
            var i = attribute.eutList.length;
            i < this.model.maxColumns;
            i++
          ) {
            attribute.eutList.push({ count: { total: -1 } });
          }
        });

        //adding rows and columns to match the max rows and columns
        for (
          var i = this.model.dashboardsUI[dashboard][eut].length;
          i < this.model.maxRows;
          i++
        ) {
          var eutList = [];
          for (var j = 0; j < this.model.maxColumns; j++) {
            eutList.push({ count: { total: -1 } });
          }
          this.model.dashboardsUI[dashboard][eut].push({ name: '', eutList });
        }
      }
    }

    for (var dashboard in this.model.totalOfDashboardUI) {
      for (var eut in this.model.totalOfDashboardUI[dashboard]) {
        this.model.totalOfDashboardUI[dashboard][eut] = [];

        var eutListTotal = [];
        for (
          var i = this.model.startAt;
          i < this.eutCollection[eut].length;
          i++
        ) {
          var idExist = this.model.deSelectCollection[eut].find(
            (id: any) => id == this.eutCollection[eut][i].eID
          );
          if (!idExist && eutListTotal.length < this.model.maxColumns) {
            switch (dashboard) {
              case 'testCaseQuality':
                var count = this.getScenarioTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              case 'testExecutionQuality':
                var count = this.getScenarioExecutedTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              case 'cleanlinessDegree':
                var count = this.getScenarioPassedTotalForEntity(
                  this.eutCollection[eut][i]
                );
                eutListTotal.push({
                  eID: this.eutCollection[eut][i].eID,
                  count,
                });
                break;
              default:
                break;
            }
          }
        }
        for (var j = eutListTotal.length; j < this.model.maxColumns; j++) {
          eutListTotal.push({ count: { total: -1 } });
        }

        eutListTotal.push({ count: { total: 0 } });
        this.model.totalOfDashboardUI[dashboard][eut].push({
          name: '',
          eutListTotal,
        });
        var eutListTotal = [];

        for (
          var i = this.model.startAt;
          i < this.eutCollection[eut].length;
          i++
        ) {
          var idExist = this.model.deSelectCollection[eut].find(
            (id: any) => id == this.eutCollection[eut][i].eID
          );
          if (!idExist && eutListTotal.length < this.model.maxColumns) {
            eutListTotal.push({ count: { total: i + 1 } });
          }
        }
        for (var j = eutListTotal.length; j < this.model.maxColumns; j++) {
          eutListTotal.push({ count: { total: 0 } });
        }
        eutListTotal.push({ count: { total: 0 } });
        this.model.totalOfDashboardUI[dashboard][eut].push({
          name: '',
          eutListTotal,
        });
      }
    }
    // console.log('this.model12', this.model);
  }






  getScenarioTotalForEntity(anEut: any) {
    return this.getScenarioTotalForEntityCheck(anEut.eID);
  }

  getScenarioExecutedTotalForEntity(anEut: any) {
    return this.getScenarioTotalForEntityCheckRunInfo(anEut.eID);
  }

  getScenarioPassedTotalForEntity(anEut: any) {
    return this.getScenarioPassedTotalForEntityRunInfo(anEut.eID);
  }

  getScenarioCountForEntity(anEut: any, attribute: any) {
    return this.getScenarioCountForEntityCheck(anEut.eID, attribute);
  }

  getScenarioExecutedForEntity(anEut: any, attribute: any) {
    return this.getScenarioExecutedForEntityRunInfo(anEut.eID, attribute);
  }

  getScenarioPassedForEntity(anEut: any, attribute: any) {
    return this.getScenarioPassedForEntityRunInfo(anEut.eID, attribute);
  }

  getTotalForAnAttribute(attribute: any, dashboard: any) {
    // model.runModel
    var count: any;
    switch (dashboard) {
      case 'testCaseQuality':
        count = this.getTotalScenarioForAnAttribute(attribute.symbol);
        return count;
        break;
      case 'testExecutionQuality':
        count = this.getTotalExecutedPercentForAnAttribute(attribute.symbol);
        return count;
        break;
      case 'cleanlinessDegree':
        count = this.getTotalPassedPercentForAnAttribute(attribute.symbol);
        return count;
        break;
      default:
        return; //// added to avoid error
        break;
    }
  }

  getTotalScenarioForAnAttribute(attribute: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = 0;
    var negative: any = 0;
    if (this.model.scenarios) {
      if (this.model.scenarios.length > 1) {
        for (var i = 0; i < this.model.scenarios.length; i++) {
          if (
            this.model.scenarios[i].cr == '+' &&
            this.model.scenarios[i].tID == attribute &&
            this.model.scenarios[i].eType == this.eutType
          ) {
            positive++;
          }
          if (
            this.model.scenarios[i].cr == '-' &&
            this.model.scenarios[i].tID == attribute &&
            this.model.scenarios[i].eType == this.eutType
          ) {
            negative++;
          }
        }
      }
    }

    count.total = positive + negative;
    count.positive = positive;
    count.negative = negative;
    return count;
  }
  getTotalExecutedPercentForAnAttribute(attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAttribute(attribute);
    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = (executed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getTotalPassedPercentForAnAttribute(attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAttribute(attribute);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = (passed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }
  getScenariosForAttribute(attribute: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    var positive: any = [];
    var negative: any = [];
    var total: any = [];
    if (this.model.scenarios) {
      for (var i = 0; i < this.model.scenarios.length; i++) {
        if (
          this.model.scenarios[i].cr == '+' &&
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          positive.push(this.model.scenarios[i]);
        }
        if (
          this.model.scenarios[i].cr == '-' &&
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          negative.push(this.model.scenarios[i]);
        }
        if (
          this.model.scenarios[i].tID == attribute &&
          this.model.scenarios[i].eType == this.model.eutType
        ) {
          total.push(this.model.scenarios[i]);
        }
      }
    }
    scenario.positive = positive;
    scenario.negative = negative;
    scenario.total = total;
    return scenario;
  }
  //// model fn close

  ///// controller fn open

  //load the persona map according to the shifted tab
  // //set the eut type and reset the value of start
  setEUTtypeChosen(eutChosen: any) {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.model.eutType = eutChosen;
    this.model.startAt = 0;

    this.allItems = this.eutCollection[eutChosen];
    this.setPage(1);

    this.loadDashboards();
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  // //when select all is checked
  // //empty my ids from delselected id list
  // // and change the value of check in the eid list also
  toggleAllDeselect(checkVal: any) {
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        this.model.deSelectCollection[this.model.eutType].splice(eID, 1);
      } else {
        var isPresent = this.model.deSelectCollection[
          this.model.eutType
        ].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        if (isPresent == -1) {
          this.model.deSelectCollection[this.model.eutType].push(
            this.eutCollection[this.model.eutType][i].eID
          );
        }
      }
    }
    this.loadDashboardsUI();
  }

  toggleSelection(eID: any) {
    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == eID
    );
    // Is currently selected
    if (isPresent > -1) {
      this.model.deSelectCollection[this.model.eutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.deSelectCollection[this.model.eutType].push(eID);
    }
    this.loadDashboardsUI();
  }

  nextPage() {
    //finding start of list
    var startPosition = this.model.startAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if (this.eutCollection[this.model.eutType].length > startPosition) {
      this.model.startAt = startPosition;
      this.loadDashboardsUI();
    }
    this.isUpDownValid();
  }

  previousPage() {
    var startPosition = this.model.startAt - this.model.listLength;
    if (startPosition >= 0) {
      this.model.startAt = startPosition;
      this.loadDashboardsUI();
    }
    this.isUpDownValid();
  }

  firstPage() {
    this.model.startAt = 0;
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  lastPage() {
    this.model.startAt =
      this.eutCollection[this.model.eutType].length -
      (this.eutCollection[this.model.eutType].length % this.model.listLength);
    this.loadDashboardsUI();
    this.isUpDownValid();
  }

  isUpDownValid() {
    this.disableDown =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? true
        : false;
    this.disableUp = this.model.startAt - 1 >= 0 ? true : false;
  }

  isChecked(ID: any) {
    var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == ID
    );
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }

  isAllSelected() {
    var count = 0;
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      var isPresent = this.model.deSelectCollection[
        this.model.eutType
      ].findIndex(
        (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
      );
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.startAt;
    if (count == 0) {
      return true;
    } else if (count == noOfRows || count < noOfRows) {
      return false;
    } else {
      return; //// added to avoid error
    }
  }

  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  entityExistsCheck(eType: any) {
    var entities: any = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  //// controller fn close

  getScenarioTotalForEntityCheck(eID: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '+'
    );
    var negative: any = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '-'
    );
    count.total = positive.length + negative.length;
    count.positive = positive.length;
    count.negative = negative.length;
    return count;
  }

  getScenarioCountForEntityCheck(eID: any, attribute: any) {
    var count: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive: any = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '+' && scenario.tID == attribute
    );
    var negative: any = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '-' && scenario.tID == attribute
    );
    count.total = positive.length + negative.length;
    count.positive = positive.length;
    count.negative = negative.length;
    return count;
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  getScenarioTotalForEntityCheckRunInfo(eID: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAnEntityRunInfo(eID);
    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = (executed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenariosForAnEntityRunInfo(eID: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    scenario.positive = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '+'
    );
    scenario.negative = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.cr == '-'
    );
    scenario.total = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID
    );
    return scenario;
  }

  getScenarioPassedTotalForEntityRunInfo(eID: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForAnEntityRunInfo(eID);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = (passed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenarioExecutedForEntityRunInfo(anEut: any, attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForEntityRunInfo(anEut, attribute);

    var executed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.status) {
            if (scenario.cr == '+') {
              executed.positive++;
            }
            if (scenario.cr == '-') {
              executed.negative++;
            }
            executed.total++;
          }
        }
      });
      percent.total = (executed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive =
          Math.round((executed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative =
          Math.round((executed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getScenariosForEntityRunInfo(eID: any, attribute: any) {
    var scenario: any = { total: [], positive: [], negative: [] };
    scenario.positive = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '+' && scenario.tID == attribute
    );
    scenario.negative = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '-' && scenario.tID == attribute
    );
    scenario.total = this.scenarios.filter(
      (scenario: any) => scenario.eID == eID && scenario.tID == attribute
    );
    return scenario;
  }

  getScenarioPassedForEntityRunInfo(anEut: any, attribute: any) {
    var percent: any = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = this.getScenariosForEntityRunInfo(anEut, attribute);
    var passed: any = { total: 0, positive: 0, negative: 0 };
    if (scenarios.total.length > 0) {
      scenarios.total.forEach((scenario: any) => {
        var run: any = this.runInfo.find(
          (run: any) => run.scenID == scenario.scenID
        );
        if (run) {
          if (run.outcome == 'P') {
            if (scenario.cr == '+') {
              passed.positive++;
            }
            if (scenario.cr == '-') {
              passed.negative++;
            }
            passed.total++;
          }
        }
      });
      percent.total = (passed.total / scenarios.total.length) * 100;
      if (scenarios.positive.length > 0) {
        percent.positive = Math.round((passed.positive / scenarios.positive.length) * 100);
      }
      if (scenarios.negative.length > 0) {
        percent.negative = Math.round((passed.negative / scenarios.negative.length) * 100);
      }
    }
    return percent;
  }

  getVideoURL(urlName: any) {
    // console.log('urlName db', urlName);
    var videoURL: any = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }
}
